import React from 'react';

/**
 * Friendly empty state when the user lacks a portal permission.
 * Prefer this over raw 403 / axios error strings.
 */
export function PermissionDenied({
  title = 'Access denied',
  message = 'You don’t have permission to view this page.',
  testId = 'permission-denied',
}) {
  return (
    <div className="grid min-h-[60vh] place-items-center px-4 py-12">
      <div className="max-w-md rounded-2xl border bg-card p-8 text-center" data-testid={testId}>
        <p className="text-base font-semibold">{title}</p>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

export default PermissionDenied;
